/* Menu click tracking for GA4 (CB-289).
   Sends three events to the live GA4 property through the gtag command queue (window.dataLayer, read by the
   gtag.js that GoKwik's snippet and the GTM container already load; no GTM change is needed):
     menu_open    menu, panel
     menu_click   menu, panel, item_type, item_title, item_url, position, search_term
     menu_search  menu, search_term, results
   "menu" is phone (the drawer), desktop (the mega menu) or search (the desktop overlay).
   Register menu, panel, item_type, item_title, item_url as event-scoped custom dimensions in GA4 to see them
   in reports; search_term is a built-in dimension. Nothing here changes what the menus do. */
(function () {
  var GA4 = 'G-TB14YZT4DJ';
  function send(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      params = params || {};
      params.send_to = GA4;
      var g = function () { window.dataLayer.push(arguments); };
      g('event', name, params);
      if (window.yhlMenuTrackDebug) console.log('[menu-track]', name, params);
    } catch (e) {}
  }
  /* the item's name only: no badge, outcome line or price */
  var NAME = '.yhl-mm__pname,.yhl-mm__tile-label,.yhl-mm__row-label,.yhl-mm__acc-label,.so__name,.dm-tile__name,.dm-pt__name,.dm-link__txt';
  function text(el) {
    var n = el.getAttribute('data-title') ? null : el.querySelector(NAME);
    return ((el.getAttribute('data-title') || (n || el).textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function path(el) {
    var h = el.getAttribute('href') || '';
    if (!h || h === '#') return '';
    try { var u = new URL(h, location.href); return u.pathname + u.search; } catch (e) { return h; }
  }
  function position(el, container) {
    var cls = (el.className || '').split(/\s+/)[0];
    if (!cls || !container) return 0;
    var all = container.querySelectorAll('.' + cls);
    return Array.prototype.indexOf.call(all, el) + 1;
  }
  function kind(el) {
    var c = ' ' + (el.className || '') + ' ';
    if (c.indexOf(' yhl-mm__product ') > -1) return c.indexOf('results') > -1 ? 'search_result' : 'product';
    if (c.indexOf(' so__row ') > -1) return 'search_result';
    if (c.indexOf(' dm-pt ') > -1 || c.indexOf(' dm-tile ') > -1) return 'product';
    if (c.indexOf(' yhl-mm__tile ') > -1) return 'concern';
    if (c.indexOf(' yhl-mm__byob-tile ') > -1) return 'byob';
    if (c.indexOf(' yhl-mm__viewall ') > -1 || c.indexOf(' dm-viewall ') > -1) return 'view_all';
    if (c.indexOf(' yhl-mm__cta ') > -1 || c.indexOf(' yhl-mm__shopall ') > -1 || c.indexOf(' yhl-mm__results-all ') > -1) return 'cta';
    if (c.indexOf(' yhl-mm__pill ') > -1) return 'learn';
    if (c.indexOf(' yhl-mm__helprow ') > -1) return 'help';
    if (c.indexOf(' yhl-mm__offer ') > -1) return 'promo';
    if (c.indexOf(' dm-link ') > -1) return 'nav';
    if (c.indexOf(' so__chip ') > -1) return 'chip';
    if (c.indexOf(' yhl-mm__login ') > -1 || c.indexOf(' yhl-mm__cart ') > -1) return 'footer';
    return 'link';
  }

  /* ---- phone drawer ---- */
  var drawer = document.getElementById('yhl-mobile-menu');
  if (drawer) {
    var mmInput = drawer.querySelector('#yhl-mm-q');
    var panelName = function (el) {
      var p = el.closest('[data-panel]');
      if (!p) return 'root';
      var key = p.getAttribute('data-panel');
      if (key === 'root') return mmInput && mmInput.value.trim() && el.closest('#yhl-mm-results') ? 'search' : 'root';
      var t = p.querySelector('.yhl-mm__title');
      return t ? text(t) : key;
    };
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('a[href],[data-mm-panel]');
      if (!t || t.hasAttribute('data-mm-close') || t.hasAttribute('data-mm-back')) return;
      if (t.hasAttribute('data-mm-panel')) {
        var target = drawer.querySelector('[data-panel="' + t.getAttribute('data-mm-panel') + '"] .yhl-mm__title');
        send('menu_open', { menu: 'phone', panel: target ? text(target) : t.getAttribute('data-mm-panel') });
        send('menu_click', { menu: 'phone', panel: panelName(t), item_type: 'open_panel', item_title: text(t), item_url: path(t), position: position(t, t.parentElement) });
        return;
      }
      var inResults = !!t.closest('#yhl-mm-results');
      var params = { menu: 'phone', panel: inResults ? 'search' : panelName(t), item_type: kind(t), item_title: text(t), item_url: path(t), position: position(t, t.closest('.yhl-mm__list,.yhl-mm__tiles,.yhl-mm__pills,.yhl-mm__help,.yhl-mm__results-list,.yhl-mm__byob-tiles,.yhl-mm__card') || t.parentElement) };
      if (inResults) { params.item_type = params.item_type === 'product' ? 'search_result' : params.item_type; params.search_term = mmInput ? mmInput.value.trim() : ''; }
      send('menu_click', params);
    }, true);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mm-open]'), function (b) {
      b.addEventListener('click', function () { send('menu_open', { menu: 'phone', panel: 'root' }); });
    });
    /* drawer search: one menu_search per rendered result list (the search script re-renders the list per query) */
    var mmList = drawer.querySelector('#yhl-mm-results .yhl-mm__results-list');
    if (mmList && mmInput && window.MutationObserver) {
      var lastQ = '';
      new MutationObserver(function () {
        var q = mmInput.value.trim();
        if (q.length < 2 || q === lastQ || !mmList.children.length) return;
        lastQ = q;
        send('menu_search', { menu: 'phone', search_term: q, results: mmList.querySelectorAll('.yhl-mm__product').length });
      }).observe(mmList, { childList: true });
      document.addEventListener('yhl:menu-closed', function () { lastQ = ''; });
    }
  }

  /* ---- desktop mega menu ---- */
  var nav = document.querySelector('.dm-nav');
  if (nav) {
    Array.prototype.forEach.call(nav.querySelectorAll('details.dm-details'), function (d) {
      d.addEventListener('toggle', function () { if (d.open) send('menu_open', { menu: 'desktop', panel: d.getAttribute('data-dm') || 'panel' }); });
    });
    nav.addEventListener('click', function (e) {
      var t = e.target.closest('a[href]');
      if (!t) return;
      var d = t.closest('details.dm-details');
      var panel = d ? (d.getAttribute('data-dm') || 'panel') : 'nav';
      var block = t.closest('[data-dm-block]');
      if (block) panel += ':' + block.getAttribute('data-dm-block');
      send('menu_click', { menu: 'desktop', panel: panel, item_type: kind(t), item_title: text(t), item_url: path(t), position: position(t, t.closest('.dm-tiles,.dm-best__strip,.dm-nav,.dm-group,.dm-panel') || t.parentElement) });
    }, true);
  }

  /* ---- desktop search overlay ---- */
  var so = document.getElementById('yhl-search');
  if (so) {
    var soInput = so.querySelector('#yhl-search-input');
    Array.prototype.forEach.call(document.querySelectorAll('[data-so-open]'), function (b) {
      b.addEventListener('click', function () { send('menu_open', { menu: 'search', panel: 'overlay' }); });
    });
    so.addEventListener('click', function (e) {
      var t = e.target.closest('a[href],[data-so-chip]');
      if (!t) return;
      send('menu_click', { menu: 'search', panel: t.closest('.so__results') ? 'results' : 'empty', item_type: kind(t), item_title: text(t), item_url: path(t), position: position(t, t.closest('.so__results,.so__chips') || t.parentElement), search_term: soInput ? soInput.value.trim() : '' });
    }, true);
    var soList = so.querySelector('.so__results');
    if (soList && soInput && window.MutationObserver) {
      var soLast = '';
      new MutationObserver(function () {
        var q = soInput.value.trim();
        if (q.length < 2 || q === soLast || !soList.children.length) return;
        soLast = q;
        send('menu_search', { menu: 'search', search_term: q, results: soList.querySelectorAll('.so__row').length });
      }).observe(soList, { childList: true });
    }
  }
})();
